(() => {
  if (window.__seshAutoProductPipelineV2) return;
  window.__seshAutoProductPipelineV2 = true;

  const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const isAr = (document.documentElement.lang || '').toLowerCase().startsWith('ar');
  const text = value => String(value || '').trim();
  const norm = value => text(value).toLowerCase().normalize('NFKD').replace(/[\u064B-\u065F]/g,'').replace(/[_-]+/g,' ');
  const split = value => text(value).split(',').map(x => x.trim()).filter(Boolean);
  const escapeHtml = value => text(value).replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));

  const readCatalog = () => [...document.querySelectorAll('[data-sesh-finder-product]')].map(el => ({
    handle: text(el.dataset.handle),
    title: text(el.dataset.title),
    url: text(el.dataset.url),
    image: text(el.dataset.image),
    price: Number(el.dataset.price || 0),
    priceFormatted: text(el.dataset.priceFormatted),
    variantId: text(el.dataset.variantId),
    variantTitle: text(el.dataset.variantTitle),
    available: el.dataset.available === 'true',
    hidden: el.dataset.hidden === 'true',
    category: text(el.dataset.category),
    goals: split(el.dataset.goals).map(norm),
    type: text(el.dataset.type),
    description: text(el.dataset.description),
    ingredients: text(el.dataset.ingredients),
    autoEnabled: el.dataset.autoEnabled === 'true',
    launchReady: el.dataset.autoLaunchReady === 'true',
    autoCategory: norm(el.dataset.autoCategory),
    autoGoals: split(el.dataset.autoGoals).map(norm),
    autoHomeShelves: split(el.dataset.autoHomeShelves).map(norm),
    autoRoutineSteps: split(el.dataset.autoRoutineSteps).map(norm),
    autoTargetArea: split(el.dataset.autoTargetArea).map(norm),
    autoProductRole: split(el.dataset.autoProductRole).map(norm),
    autoActiveIngredients: text(el.dataset.autoActiveIngredients),
    autoRelatedHandles: split(el.dataset.autoRelatedHandles),
    autoBundleTitleEn: text(el.dataset.autoBundleTitleEn),
    autoBundleTitleAr: text(el.dataset.autoBundleTitleAr),
    autoBundleCopyEn: text(el.dataset.autoBundleCopyEn),
    autoBundleCopyAr: text(el.dataset.autoBundleCopyAr),
    autoHeroAccent: text(el.dataset.autoHeroAccent)
  }));

  const isReady = p => p && p.handle && p.available && !p.hidden && p.image && p.variantId;
  const isAutoReady = p => isReady(p) && p.autoEnabled && p.launchReady;
  const represented = (container, handle) =>
    [...container.querySelectorAll('a[href*="/products/"]')].some(a => (a.getAttribute('href') || '').includes('/products/' + handle)) ||
    !!container.querySelector('[data-sesh-product-handle="' + CSS.escape(handle) + '"]');

  const eyebrowFor = p => {
    if (p.autoCategory === 'fragrance') return isAr ? 'عطر' : 'FRAGRANCE';
    if (p.autoCategory === 'body') return isAr ? 'عناية بالجسم' : 'BODY CARE';
    if (p.autoCategory === 'teeth') return isAr ? 'ابتسامة' : 'SMILE';
    if (p.autoCategory === 'nails') return isAr ? 'أظافر' : 'NAILS';
    if (p.autoProductRole.some(x => x.includes('sunscreen') || x === 'spf')) return 'SPF';
    if (p.autoProductRole.some(x => x.includes('cleanser'))) return isAr ? 'تنظيف' : 'CLEANSE';
    if (p.autoProductRole.some(x => x.includes('eye'))) return isAr ? 'منطقة العين' : 'EYE CARE';
    if (p.autoProductRole.some(x => x.includes('cream'))) return isAr ? 'كريم' : 'CREAM';
    if (p.autoProductRole.some(x => x.includes('serum'))) return isAr ? 'سيرم' : 'SERUM';
    return isAr ? 'جديد SESH' : 'NEW AT SESH';
  };

  const card = (p, eyebrow) => {
    const title = escapeHtml(p.title.replace(/^SESH\s*-\s*/i,''));
    const url = escapeHtml(p.url) + (p.variantId ? '?variant=' + encodeURIComponent(p.variantId) : '');
    const size = p.variantTitle && p.variantTitle !== 'Default Title' ? '<span>' + escapeHtml(p.variantTitle) + '</span>' : '';
    return '<article class="shpc sesh-auto-card shpc--compact" data-sesh-card data-sesh-auto-card data-sesh-product-handle="' + escapeHtml(p.handle) + '">' +
      '<a class="shpc__image" href="' + url + '"><img src="' + escapeHtml(p.image) + '" alt="' + title + '" loading="lazy"></a>' +
      '<div class="shpc__body"><small class="shpc__eyebrow">' + escapeHtml(eyebrow || eyebrowFor(p)) + '</small>' +
      '<a class="shpc__title" href="' + url + '">' + title + '</a><div class="shpc__meta"><strong>' + escapeHtml(p.priceFormatted) + '</strong>' + size + '</div>' +
      '<button type="button" class="sesh-auto-card__add" data-sesh-auto-add data-variant-id="' + escapeHtml(p.variantId) + '">' + (isAr ? 'أضيفي للسلة' : 'Add to cart') + '</button></div></article>';
  };

  const targetMatch = (p, container) => {
    const categories = split(container.dataset.seshAutoCategory).map(norm);
    const goals = split(container.dataset.seshAutoGoal).map(norm);
    const shelves = split(container.dataset.seshAutoHomeShelf).map(norm);
    const roles = split(container.dataset.seshAutoRole).map(norm);
    const areas = split(container.dataset.seshAutoTargetArea).map(norm);
    if (categories.length && !categories.includes(p.autoCategory)) return false;
    if (goals.length && !goals.some(g => p.autoGoals.includes(g))) return false;
    if (shelves.length && !shelves.some(s => p.autoHomeShelves.includes(s))) return false;
    if (roles.length && !roles.some(r => p.autoProductRole.some(x => x.includes(r)) || p.autoRoutineSteps.some(x => x.includes(r)))) return false;
    if (areas.length && !areas.some(a => p.autoTargetArea.some(x => x.includes(a)))) return false;
    return true;
  };

  const injectTargets = autoProducts => {
    document.querySelectorAll('[data-sesh-auto-category],[data-sesh-auto-goal],[data-sesh-auto-home-shelf],[data-sesh-auto-role],[data-sesh-auto-target-area]').forEach(container => {
      autoProducts.filter(p => targetMatch(p, container) && !represented(container, p.handle)).slice(0, 4)
        .forEach(p => container.insertAdjacentHTML('beforeend', card(p)));
    });
  };

  const injectNewArrivals = autoProducts => {
    const grid = document.querySelector('[data-sesh-auto-new-arrivals]');
    if (!grid) return;
    const existing = grid.querySelectorAll('[data-sesh-card], .shpc').length;
    autoProducts.filter(p => !represented(grid, p.handle)).slice(0, Math.max(0, 6 - existing))
      .forEach(p => grid.insertAdjacentHTML('beforeend', card(p, isAr ? 'وصل حديثًا' : 'JUST LANDED')));
  };

  const candidateRole = p => {
    const hay = norm([p.type,p.description,p.ingredients,p.category,p.goals.join(' ')].join(' '));
    if (/sunscreen|spf/.test(hay)) return 'sunscreen';
    if (/cleanser|cleansing/.test(hay)) return 'cleanser';
    if (/peel|exfol/.test(hay)) return 'exfoliate';
    if (/eye/.test(hay)) return 'eye';
    if (/serum/.test(hay)) return 'serum';
    if (/cream|moistur/.test(hay)) return 'cream';
    if (/lotion/.test(hay)) return 'lotion';
    if (/fragrance|perfume|mist/.test(hay)) return 'fragrance';
    return '';
  };

  const compatibility = (source, candidate) => {
    if (!isReady(candidate) || candidate.handle === source.handle) return -999;
    let score = 0;
    if (source.autoRelatedHandles.includes(candidate.handle)) score += 120;
    const candidateGoals = candidate.goals || [];
    score += source.autoGoals.filter(g => candidateGoals.includes(g)).length * 10;
    const sr = source.autoProductRole[0] || source.autoRoutineSteps[0] || '';
    const cr = candidateRole(candidate);
    const good = ['cleanser>serum','cleanser>cream','serum>cream','serum>sunscreen','cream>sunscreen','exfoliate>cream','eye>serum','eye>cream'];
    if (good.includes(sr + '>' + cr)) score += 28;
    if (source.autoCategory === candidate.category) score += 6;
    const sourceHay = norm([source.autoActiveIngredients,source.description].join(' '));
    const candidateHay = norm([candidate.ingredients,candidate.description].join(' '));
    if (/retinol|retinal|retinyl/.test(sourceHay) && /retinol|retinal|retinyl/.test(candidateHay)) score -= 60;
    if (/retinol|retinal|retinyl/.test(sourceHay) && /glycolic|salicylic|lactic|aha|bha|peel/.test(candidateHay)) score -= 45;
    if (sr && cr && sr === cr && !['fragrance','body'].includes(source.autoCategory)) score -= 18;
    return score;
  };

  const companionsFor = (source, products, count = 2) => {
    const explicit = source.autoRelatedHandles.map(handle => products.find(p => p.handle === handle)).filter(isReady);
    if (explicit.length) return explicit.slice(0, count);
    return products.map(p => ({p,score:compatibility(source,p)})).filter(x => x.score > 15).sort((a,b) => b.score - a.score).slice(0,count).map(x => x.p);
  };

  const injectBundles = (autoProducts, allProducts) => {
    const section = document.querySelector('[data-sesh-auto-bundles-section]');
    const grid = document.querySelector('[data-sesh-auto-bundles-grid]');
    if (!section || !grid) return;
    let added = 0;
    autoProducts.filter(p => !grid.querySelector('[data-sesh-auto-bundle-for="' + CSS.escape(p.handle) + '"]')).slice(0,4).forEach(source => {
      const mates = companionsFor(source, allProducts, 2);
      if (!mates.length) return;
      const bundle = [source, ...mates];
      const title = isAr ? (source.autoBundleTitleAr || source.title) : (source.autoBundleTitleEn || source.title);
      const copy = isAr ? (source.autoBundleCopyAr || 'اختيارات مكملة لدور المنتج في الروتين.') : (source.autoBundleCopyEn || 'Complementary picks matched to the product’s role in the routine.');
      const accent = source.autoHeroAccent || '#D9EDF7';
      const html = '<article class="sbw__auto-card sesh-auto-bundle" data-sesh-auto-bundle-for="' + escapeHtml(source.handle) + '" style="--auto-accent:' + escapeHtml(accent) + ';">' +
        '<div class="sbw__auto-copy"><span>' + (isAr ? 'جديد + متظبط مع روتينك' : 'NEW + FITS RIGHT IN') + '</span><h3>' + escapeHtml(title) + '</h3><p>' + escapeHtml(copy) + '</p></div>' +
        '<div class="sbw__auto-products">' + bundle.map(p => card(p, p === source ? (isAr ? 'جديد' : 'NEW') : (isAr ? 'يكمله' : 'PAIR WITH'))).join('') + '</div>' +
        '<button class="sbw__add" type="button" data-sesh-auto-bundle-add data-variants="' + bundle.map(p => escapeHtml(p.variantId)).join(',') + '"><span>' + (isAr ? 'أضيفي المجموعة للسلة' : 'Add set to cart') + '</span><span>→</span></button></article>';
      grid.insertAdjacentHTML('beforeend', html);
      added++;
    });
    if (added || grid.children.length) section.hidden = false;
  };

  const injectGrowth = (autoProducts, allProducts) => {
    const section = document.querySelector('[data-sesh-product-growth]');
    const grid = section?.querySelector('[data-sesh-product-growth-grid]');
    if (!section || !grid || grid.children.length) return;
    const source = autoProducts.find(p => p.handle === section.dataset.seshCurrentHandle);
    if (!source) return;
    companionsFor(source, allProducts, 2).forEach(p => grid.insertAdjacentHTML('beforeend', card(p, isAr ? 'يكمل المنتج' : 'ROUTINE MATCH')));
  };

  const addItems = async ids => {
    const clean = ids.filter(Boolean);
    if (!clean.length) return;
    const response = await fetch(rootPath + 'cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:clean.map(id => ({id:Number(id),quantity:1}))})
    });
    if (!response.ok) throw new Error('Cart add failed');
    document.dispatchEvent(new CustomEvent('sesh:cart-updated',{bubbles:true}));
  };

  document.addEventListener('click', async event => {
    const single = event.target.closest('[data-sesh-auto-add]');
    const bundle = event.target.closest('[data-sesh-auto-bundle-add]');
    const button = single || bundle;
    if (!button) return;
    event.preventDefault();
    const ids = single ? [single.dataset.variantId] : split(bundle.dataset.variants);
    const old = button.textContent;
    button.disabled = true;
    try {
      await addItems(ids);
      button.textContent = isAr ? 'اتضافت ✓' : 'Added ✓';
      setTimeout(() => { button.textContent = old; button.disabled = false; }, 1300);
    } catch (error) {
      button.textContent = isAr ? 'جربي تاني' : 'Try again';
      setTimeout(() => { button.textContent = old; button.disabled = false; }, 1700);
    }
  });

  const boot = () => {
    const allProducts = readCatalog();
    const autoProducts = allProducts.filter(isAutoReady);
    if (!autoProducts.length) return;
    injectNewArrivals(autoProducts);
    injectTargets(autoProducts);
    injectBundles(autoProducts, allProducts);
    injectGrowth(autoProducts, allProducts);
    window.SESH_AUTO_PRODUCTS = { products:autoProducts, allProducts, companionsFor:handle => {
      const source = autoProducts.find(p => p.handle === handle);
      return source ? companionsFor(source, allProducts, 3) : [];
    }};
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
  document.addEventListener('shopify:section:load', () => setTimeout(boot, 50));
})();